import { z } from "zod";
// Location enum schema
export const LocationSchema = z.enum(['SALEM', 'BOSTON', 'METHUEN', 'CAPE']);
// Report type enum schema  
export const ReportTypeSchema = z.enum(['daily', 'weekly', 'monthly']);
// Report status enum schema
export const ReportStatusSchema = z.enum(['processing', 'completed', 'failed']);
